<template>
<div class="static-order-main">
    <div class="static-order-top">
        <el-form ref="form" :model="form" label-position="left" class="demo-form-inline" :inline="true">
            <el-form-item>
                <el-input v-model="form.searchKey" :placeholder="$t('staticisp_orders.form.order_no_placeholder')" data-inputPlaceholderI18n="1"></el-input>
            </el-form-item>
            <el-form-item>
                <el-col :span="12">
                    <el-form-item prop="startTime">
                        <el-date-picker type="date" :placeholder="$t('staticisp_orders.form.start_time_placeholder')" v-model="form.startTime" style="width: 100%;">
                        </el-date-picker>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item prop="endTime">
                        <el-date-picker type="date" :placeholder="$t('staticisp_orders.form.end_time_placeholder')" v-model="form.endTime" style="width: 100%;"></el-date-picker>
                    </el-form-item>
                </el-col>
            </el-form-item>
            <el-form-item>
                <el-select v-model="form.selectPopUp" :placeholder="$t('staticisp_orders.form.pay_status_placeholder')">
                    <el-option
                        v-for="(item,key) in selectPopUpList"
                        :key="key"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                    </el-select>
            </el-form-item>
            <el-form-item>
                <el-button @click="onSearch" v-cloak>{{ $t('staticisp_orders.form.search') }}</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="static-order-center">
        <div class="list-table">
            <el-table :data="tableData" :cell-class-name="tableCellClassName" style="width: 100%" height="100%" v-loading="searching">
                <el-table-column prop="order_no":label="tableName[0]" header-align="center" align="center" width="160">
                </el-table-column>
                <el-table-column :label="tableName[1]" header-align="center" align="center" width="160">
                    <template slot-scope="scope">
                        <span>{{ scope.row.money }}</span>
                        <div v-if="scope.row.originalMoney" class="original-money">
                            {{ scope.row.originalMoney }}
                        </div>
                        <div v-if="scope.row.refundAmountText" style="color: red; margin-top: 5px">
                            {{ $t('staticisp_orders.refund_label', { amount: scope.row.refundAmountText }) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="pay_type" :label="tableName[2]" header-align="center" align="center" width="86">
                </el-table-column>
                <el-table-column prop="area" :label="tableName[3]" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="ip_num" :label="tableName[4]" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="timeLength" :label="tableName[5]" header-align="center" align="center">
                </el-table-column>
                <el-table-column prop="payTime" :label="tableName[6]" header-align="center" align="center" width="200">
                </el-table-column>
                <el-table-column prop="processStatusText" :label="tableName[7]" header-align="center" align="center">
                </el-table-column>
                <!-- <el-table-column prop="refundAmountText" :label="tableName[8]" header-align="center" align="center">
                </el-table-column> -->
                <el-table-column :label="tableName[9]" header-align="center" align="center" width="150">
                    <template slot-scope="scope">
                        <el-tooltip popper-class="table-item" effect="light" :content="operate.detail" placement="top"  v-show="scope.row.pay_status_table != 'no'">
                            <a class="operate" :href="'/ucenter/staticisp/ips?orderNo=' + scope.row.order_no" v-show="scope.row.pay_status_table != 'no'"><img src="@/assets/index/img/ucenter/static_order/icon_detail.png" alt=""></a>
                        </el-tooltip>
                        <el-tooltip popper-class="table-item" effect="light" :content="operate.export" placement="top" v-show="scope.row.pay_status_table != 'no'">
                            <a class="operate" href="javascript:;" v-show="scope.row.pay_status_table != 'no'"  @click="exportIp(scope.row)" ><img src="@/assets/index/img/ucenter/static_order/icon_export.png" alt=""></a>
                        </el-tooltip>
                        <el-tooltip popper-class="table-item" effect="light" :content="operate.copy" placement="top" v-show="scope.row.pay_status_table != 'no'">
                            <a class="operate" href="javascript:;" v-show="scope.row.pay_status_table != 'no'"  @click="copyIps(scope.row)" ><img src="@/assets/index/img/ucenter/static_order/icon_copy.png" alt=""></a>
                        </el-tooltip>
                        <el-tooltip popper-class="table-item" effect="light" :content="operate.invoice" placement="top" v-show="scope.row.pay_status_table != 'no'">
                            <a class="operate" href="javascript:;" v-show="scope.row.pay_status_table != 'no'"  @click="exportInvoice(scope.row)" ><img src="@/assets/index/img/ucenter/static_order/icon_xz.png" alt=""></a>
                        </el-tooltip>
                    </template> 
                </el-table-column>
                <el-table-column header-align="center" width="150px" align="center">
                    <template slot-scope="scope">
                        <div class="gopay" :id="scope.row.order_id" v-show="scope.row.show_pay">
                            <p>{{ points_seconds(scope.row.show_pay_time) }}</p>
                            <div>
                                <a href="javascript:;" @click="gopay(scope.row,scope.$index)">{{ $t('staticisp_orders.action.pay') }}</a>
                                <a href="javascript:;" @click="gocancel(scope.row,scope.$index)">{{ $t('staticisp_orders.action.cancel') }}</a>
                            </div>
                        </div>
                    </template> 
                </el-table-column>
            </el-table>
            <el-pagination
                small
                layout="total, prev, pager, next, sizes"
                @current-change = "handleCurrentChange"
                @size-change="handleSizeChange"
                :current-page.sync="curPage"
                :page-size.sync="paginationSize"
                :size="paginationSize"
                :total="paginationTotal"
                :page-sizes="$store.state.userPreferences?.paginationSizes || [10, 20, 50, 100]"
                >
            </el-pagination>
        </div>
    </div>
</div>
</template>

<script>
import clipboard from "clipboard";
import {getOrderList, cancelOrder, exportStaticIps, extractOrderProxyAccounts, exportInvoice} from '@/http/api/order'
import {utcTimestampToLocalTime, localOrderDayBoundary } from '@/util/human'

export default {
  name: 'staticisp-orders',
  components: {
  },

  data() {
    return {
        searching: false,

        form:{
            searchKey:'',
            startTime:'',
            endTime:'',
            selectPopUp:"",
        },
        
        tableData:[],

        highlight_order_no:'',
        highlightedRows: [],
        
        paginationTotal:0,
        curPage:1,
        setIntervalList:{0:"",1:"",2:"",3:"",4:"",5:"",6:"",7:"",8:"",9:"",},//Did not pay the setInterval used store 30 minutes 
    }
  },
  inject: ['updateCurrentMenuUrl'],
  computed: {
    tableName() {
      return this.$t('staticisp_orders.table_name')
    },
    selectPopUpList(){
      return [
          {label: this.$t('staticisp_orders.form.pay_status.all'), value:""},
          {label: this.$t('staticisp_orders.form.pay_status.paid'), value:2},
          {label: this.$t('staticisp_orders.form.pay_status.unpaid'), value:1},
      ]
    },
    operate(){
      return this.$t('staticisp_orders.operate')
    },
    isLogin() {
      return this.$store.state.isLogin;
    },
    paginationSize() {
      return this.$store.state.userPreferences?.paginationSize || 10;
    },
  },
  watch: {
  },
  created() {
    this.updateCurrentMenuUrl('/ucenter/staticisp/orders');

    this.highlight_order_no = this.$route.query?.orderNo ?? ''
  },
  mounted() {
    if (this.isLogin) {
      this.get_order_list(1);
    } else {
      location.href='/login/'
    }
  },
  methods: {
    gocancel(row, index){
      let self = this;
      if (row.show_pay){
        this.$modal.loading('Loading');
        let order_no = row.order_no;
        cancelOrder({type: 2, order_no: order_no}).then( res => {
          self.tableData = self.tableData.filter(o => o.order_no !== order_no);

          this.$message.success(self.$t('staticisp_orders.message.cancel_success'));
        }).catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "cancel order error");
        }).finally(() => {
          this.$modal.closeLoading();
        });
      }else{
        this.$message.error(self.$t('staticisp_orders.message.error_canceled'));
        return false;
      }
    },
    //buy 
    gopay(row,index){
        let self = this;
        if(row.show_pay){
          let item = {
            type: 2,
            order_no: row.order_no,
          }
          this.$router.push({ path: '/payment', query: item })
        }else{
          this.$message.error(self.$t('staticisp_orders.message.error_paid'));
          return false;
        }
    },

    //Remove all the countdown 
    clearInt(){
        let self = this;
        for (const index in self.setIntervalList) {
            if(self.setIntervalList[index]){
                window.clearInterval(self.setIntervalList[index]);
            }
        }
    },
    //Determine whether to show the purchase and buy the remaining time 
    bool_show_pay(){
        let self = this;
        for (const index in this.tableData) {
          if(this.tableData[index].show_pay){
            this.setIntervalList[index] = setInterval(() => {
              this.tableData[index].show_pay_time--
              if(this.tableData[index].show_pay_time<=0){
                  this.tableData[index].show_pay=false
                  window.clearInterval(this.setIntervalList[index]);
              }
            }, 1000);
          }
        }
    },
    //Turn second countdown 
    points_seconds(time){
        let points_time = Math.floor(time/60)
        let seconds_time = time%60
        let points = points_time<10?'0'+points_time:points_time
        let seconds = seconds_time<10?'0'+seconds_time:seconds_time
        return points + ":" + seconds
    },
    onSearch:function(){
        this.get_order_list(1)  
    },
    get_order_list:function(page){
        let self = this
        self.searching = true;
        self.clearInt();

        var size = self.paginationSize;
        if (typeof(page) == 'undefined') {
            page = 1;
        }
        self.curPage = page
        let param = {
            page: page, 
            limit: size,
            type: 2,
            order_no: self.form.searchKey,
            start_time: self.form.startTime ? localOrderDayBoundary(self.form.startTime) : '',
            end_time: self.form.endTime ? localOrderDayBoundary(self.form.endTime, true) : '',
            pay_status:self.form.selectPopUp
        }
        self.tableData = []

        getOrderList(param).then(res => {
          let timestamp = res.time
          let obj = res.data

          self.paginationTotal = obj.count

          let list = obj.list || [];
          for (let i = 0; i < list.length; i++) {
              let close_time = Number(list[i]['create_time'])+1800
              if(close_time > timestamp && list[i]['pay_status'] == 1 && list[i]['deal_status'] != 5){
                  list[i].show_pay_time = close_time - timestamp - 20
                  list[i].show_pay = true
              } else {
                  list[i].show_pay_time = 0
                  list[i].show_pay = false
              }
              list[i].money = self.formatOrderAmount(list[i], 'pay_price')
              list[i].originalMoney = Number(list[i]['total_price']) > Number(list[i]['pay_price']) ? self.formatOrderAmount(list[i], 'total_price') : ''
              list[i].timeLength = list[i]['time_length'] == 0 ? 0 : list[i]['time_length'] + ' ' + self.$t('staticisp_orders.days');
              list[i].payTime = list[i]['pay_time'] == 0 ? '--' : utcTimestampToLocalTime(list[i]['pay_time']*1000, 1);
              list[i].pay_status_table = list[i]['pay_status'] == 2 && list[i]['deal_status'] != 5 ? 'yes' : 'no';
              if(list[i]['pay_type']=='1'){
                  list[i]['pay_type']= self.$t('staticisp_orders.pay_type.stripe')
              } else if(list[i]['pay_type']=='2'){
                  list[i]['pay_type']=self.$t('staticisp_orders.pay_type.alipay')
              } else if(list[i]['pay_type']=='3'){
                  list[i]['pay_type']=self.$t('staticisp_orders.pay_type.balance')
              } else {
                  // An unpaid order has not selected a payment channel yet. The
                  // legacy value 0 is an internal sentinel, not a display value.
                  list[i]['pay_type']='--'
              }
              const paymentDeadline = list[i]['payment_timeout_at']
                  ? Date.parse(String(list[i]['payment_timeout_at']).replace(' ', 'T') + (String(list[i]['payment_timeout_at']).endsWith('Z') ? '' : 'Z')) / 1000
                  : Number(list[i]['create_time']) + 1800;
              if (Number(list[i]['pay_status']) === 1) {
                  list[i].processStatusText = paymentDeadline > timestamp
                      ? self.$t('staticisp_orders.deal_status.pending_payment')
                      : self.$t('staticisp_orders.deal_status.expired');
              } else {
                  list[i].processStatusText = list[i]['deal_status'] == 5 ? self.$t('staticisp_orders.deal_status.cancelled') : list[i]['deal_status'] == 4 ? self.$t('staticisp_orders.deal_status.fail') : list[i]['deal_status'] == 3 ? self.$t('staticisp_orders.deal_status.done') : list[i]['deal_status'] == 2 ? self.$t('staticisp_orders.deal_status.processing') : list[i]['deal_status'] == 1 ? self.$t('staticisp_orders.deal_status.waiting') : '--';
              }
              list[i].refundAmountText = list[i]['refund_status'] !== 'none' ? self.formatOrderAmount(list[i], 'refunded_amount') : "";
              self.tableData.push(list[i])
          }
          self.bool_show_pay()
          this.$nextTick(() => {
            this.highlightRows();
          });
        }).catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "get order list error");
        }).finally(() => {
          self.searching = false;
        });
    },
    highlightRows() {
      this.highlightedRows = [this.highlight_order_no];
      this.$forceUpdate();
      setTimeout(() => {
        this.highlightedRows = [];
      }, 2000); // 设置为与 CSS transition 时间一致
    },
    tableCellClassName:function({row, column, rowIndex, columnIndex}){
      if (this.highlightedRows.includes(row.order_no)) {
        return 'row-highlight-transition';
      }
      if (row.order_no === this.highlight_order_no) {
        return 'row-highlight';
      }
      return '';
    },
    getCurrencySymbol(currency) {
      return currency === 'cny' ? '¥' : '$';
    },
    formatOrderAmount(order, field) {
      const value = Number(order[field] || 0).toFixed(2);
      return this.getCurrencySymbol(order.pay_currency) + value;
    },
    handleCurrentChange:function(){
        if (this.isLogin) {
            this.get_order_list(this.curPage)
        } else {
            goto_login();
        }
    },
    handleSizeChange(val) {
      if (this.isLogin) {
        this.$store.commit('updateUserPreference', { paginationSize: val });
        this.get_order_list(1)
      } else {
        goto_login();
      }
    },
    exportIp:function(row){
        let self = this
        let data={
            orderNo:row.order_no+'',
            status: 0,
            region:row.region,
        }
        this.$modal.loading('Loading');
        exportStaticIps(data).then(res => {
          let blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }); 
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.setAttribute('download', 'PurchaseHistory.xlsx');
          link.download = "PurchaseHistory.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        })
        .catch(e => {
          // self.$message.error(e.message ?? e.msg ?? "export static ips error");
        }).finally(() => {
            this.$modal.closeLoading();
        });
    },
    copyIps: function(row) {
      let self = this
      let data={
          orderNo:row.order_no+'',
          status: 0,
          region:row.region,
      }
      this.$modal.loading('Loading');
      extractOrderProxyAccounts(data).then(res => {
        let accounts = res.data.accounts
        clipboard.copy(accounts.join('\n'))
        self.$message({
            message: this.$t('staticisp_orders.message.copied'),
            type: 'success',
        })
      })
      .catch(e => {
        // self.$message.error(e.message ?? e.msg ?? "export static ips error");
      }).finally(() => {
          this.$modal.closeLoading();
      });
    },
    exportInvoice: function(row){
      let self = this
      var param = {
          order_no: row.order_no,
      };
      this.$modal.loading('Loading');
      exportInvoice(param).catch(e => {
        self.$message.error(e.message ?? e.msg ?? "Invoice download failed");
      }).finally(() => {
          this.$modal.closeLoading();
      });
    },
  }
}

</script>

<style scoped lang="scss">
  // Loading styles
  ::v-deep .el-loading-mask {
    display: flex;
    justify-content: center;
    align-items: center;
    
    .el-loading-spinner {
      margin: 0;
      width: fit-content;
    }
  }

  // Row highlight animations
  ::v-deep .row-highlight {
    &-transition {
      background-color: #db2a0f;
      transition: background-color 1s ease-in-out;
    }
    
    &-static {
      background-color: #e97a05;
      transition: background-color 2s ease-in-out;
    }
  }

  // Payment cell styles
  .cell {
    .gopay {
      display: flex;
      flex-direction: column;
      justify-content: center;
      
      p {
        line-height: 0.9;
      }
      
      a {
        display: inline-block;
        color: #276dfd;
        text-decoration: underline;
        line-height: 1;
        
        &:first-child {
          margin-right: 10px;
        }
      }
    }
  }

  .original-money {
    margin-top: 4px;
    color: rgba(17, 24, 46, 0.45);
    font-size: 12px;
    line-height: 1;
    text-decoration: line-through;
  }

  ::v-deep .el-tooltip {
    img {
      display: inline-block;
    }
  }

  // Main container
  .static-order-main {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;

    // Top section form styles
    .static-order-top {
      ::v-deep .demo-form-inline {
        > .el-form-item {
          &:first-of-type, &:nth-of-type(3) {
            width: 100%;
            max-width: 266px;
            height: 56px;
            background-color: #f0f2f9;
            border-radius: 10px;

            .el-form-item__content {
              width: 100% !important;
              height: 100% !important;

              .el-input, .el-select {
                width: 100%;
                height: 100%;

                .el-input__inner {
                  width: 100%;
                  height: 100%;
                  background-color: #f0f2f9;
                  border-radius: 10px;
                  border: none;
                  outline: none;
                  font-family: "Poppins-Medium";
                  font-size: 16px;
                  color: #11182e;

                  &::placeholder {
                    font-family: "Poppins-Medium";
                    font-size: 16px;
                    color: rgba(204, 204, 204, 0.6);
                  }
                }
              }
            }
          }

          &:nth-of-type(2) {
            width: 100%;
            max-width: 556px;

            .el-form-item__content {
              width: 100%;

              .el-form-item {
                width: calc(100% - 12px);

                .el-input {
                  .el-input__inner {
                    width: 100%;
                    border: none;
                    padding-left: 45px;
                    height: 56px;
                    background-color: #f0f2f9;
                    border-radius: 10px;
                    font-family: "Poppins-Medium";
                    font-size: 16px;
                    color: #11182e;

                    &::placeholder {
                      font-family: "Poppins-Medium";
                      font-size: 16px;
                      color: rgba(204, 204, 204, 0.6);
                    }
                  }

                  .el-input__icon {
                    font-size: 24px;
                    font-weight: bold;
                    color: #276dfd;
                    line-height: 56px;
                  }
                }
              }
            }
          }

          &:last-of-type {
            width: 100%;
            max-width: 163px;
            height: 56px;

            .el-form-item__content {
              width: 100% !important;
              height: 100% !important;

              .el-button {
                width: 100%;
                height: 100%;
                background-color: #276dfd;
                border-radius: 10px;
                font-family: "Poppins-Medium";
                font-size: 16px;
                font-weight: normal;
                font-stretch: normal;
                letter-spacing: 0px;
                color: #ffffff;
              }
            }
          }
        }
      }
    }

    // Center section table styles
    .static-order-center {
      flex: 1;
      display: flex;
      flex-direction: column;
      min-height: 0;

      ::v-deep .list-table {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-height: 0;
        padding-bottom: 60px; // 为分页组件预留空间

        .el-table {
          flex: 1;
          overflow: auto;

          &::before {
            height: 0px;
          }

          .el-table__body-wrapper {
            border-radius: 0px 0px 10px 10px;
          }

          .el-table__header {
            thead {
              width: 100%;
              height: 56px;
              background-color: #dce4fa;
              border-radius: 10px 10px 0px 0px;

              tr {
                height: 56px;
                background-color: #dce4fa;

                th.el-table__cell {
                  height: 56px;
                  background-color: #dce4fa;

                  .cell {
                    font-family: "Poppins-Medium";
                    font-size: 16px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: #11182e;
                  }

                  &:first-of-type {
                    border-radius: 10px 0px 0px 0px;
                  }

                  &:nth-of-type(10) {
                    border-radius: 0px 10px 0px 0px;
                  }
                }
              }
            }
          }

          .el-table__body {
            tbody {
              tr.el-table__row {
                td.el-table__cell {
                  height: 56px;

                  .cell {
                    font-family: "Poppins-Medium";
                    font-size: 14px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 0px;
                    color: rgba(17, 24, 46, 0.6);

                    .operate {
                      position: relative;
                      display: inline-block;

                      .operate-tips {
                        position: absolute;
                        right: 0;
                        top: 50%;
                        padding: 4px 11px;
                        background-color: rgba(34, 50, 101, 0.1);
                        border-radius: 6px;
                        font-family: "Poppins-Medium";
                        font-size: 14px;
                        font-weight: normal;
                        font-stretch: normal;
                        line-height: 21px;
                        letter-spacing: 0px;
                        color: #223265;
                      }

                      &:first-of-type, &:nth-of-type(2) {
                        margin-right: 17px;
                      }

                      &:last-of-type {
                        margin-left: 17px;
                      }
                    }
                  }
                }

                &:nth-child(odd) {
                  background-color: #fcfcfe;
                }

                &:nth-child(even) {
                  background-color: #f0f2f9;
                }
              }
            }
          }
        }

        .el-pagination {
          padding: 10px 0;
          text-align: center;
        }
      }
    }
  }
</style>
